/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_TitleInputs */

const en_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account`)
};

const pl_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto`)
};

/**
* | output |
* | --- |
* | "Create your account" |
*
* @param {Auth_Signup_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_signup_title = /** @type {((inputs?: Auth_Signup_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_signup_title(inputs)
	return en_auth_signup_title(inputs)
});